import { defineMessages } from 'react-intl-next';

export default defineMessages({
	label: {
		id: 'fabric.editor.ai.screens.prompt.mentionButton.label',
		defaultMessage: 'Mention someone or a team',
		description: 'Mention button label within the Prompt screen',
	},
});
